import React, { PropsWithChildren } from 'react';

import { Dialog, DialogContent, DialogTrigger } from 'components/ui/dialog';

export function IframeDialog({ title, src, children }: PropsWithChildren<{ title: string; src: string }>) {
  return (
    <Dialog>
      <DialogTrigger asChild>{children}</DialogTrigger>
      <DialogContent className="h-[85vh] w-[calc(100vw-32px)] max-w-[640px] p-0 md:h-[80vh]">
        <iframe src={src} title={title} width="100%" height="100%" className="rounded" allow="clipboard-write" />
      </DialogContent>
    </Dialog>
  );
}
